export default "__VITE_ASSET__mnGvNznE__"